var map = {
	"./2AGK.png": 95977,
	"./5AGK.png": 17254,
	"./6AGK.png": 60937,
	"components/Catalog/AGK/img/allDoor/prgray/2AGK.png": 95977,
	"components/Catalog/AGK/img/allDoor/prgray/5AGK.png": 17254,
	"components/Catalog/AGK/img/allDoor/prgray/6AGK.png": 60937
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89717;